import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import IconSvgComponent from 'shared/ui/icons/IconSvgComponent';
import { BackButton } from 'shared/styles/components/BackButton';
import { getFormattedDuid } from 'shared/utilities/general';
import { NO_PAGE_DATA } from 'shared/constants/messages';
import { JsonExpandCollapse, JsonTree } from 'shared/styles/components/JsonTree';
import JSONTree from 'react-json-view';
import styled from 'styled-components';

const DEFAULT_JSON_LENGTH = 2;
const ExpandCaret = { paddingLeft: '4px' };

export const DetailContainer = styled.div`
  > * > .backbtn:hover {
    cursor: pointer;
  }
`;

// Expand All Component
const ExpandAll = () => {
  return (
    <>
      <span>Expand All</span>
      <IconSvgComponent style={ExpandCaret} svgFileName={'caret-front'} />
    </>
  );
};

// Collapse All Component
const CollapseAll = () => {
  return (
    <>
      <span>Collapse All</span>
      <IconSvgComponent style={ExpandCaret} svgFileName={'caret-down'} />
    </>
  );
};

const orderDeviceInfo = ({ close, devices, addons, showDevice = false, showAddon = false, organizationId }) => {
  const [expandAllStateInfo, setExpandAllStateInfo] = useState(true);
  const [viewStateInfo, setViewStateInfo] = useState(true);

  // To re-render the State Info JSON object for expand or collapse all operation
  useEffect(() => {
    if (!viewStateInfo) {
      setViewStateInfo(true);
    }
  }, [viewStateInfo]);

  return (
    <DetailContainer>
      {showDevice ? (
        <div className="vehicleInfoSubs">
          <>
            <JsonTree>
              <div className="tree-grid">
                {devices && Array.isArray(devices) && devices.length > 0 ? (
                  <>
                    <h4>
                      Vehicle Information
                      <JsonExpandCollapse
                        onClick={() => {
                          setExpandAllStateInfo((prev) => {
                            setViewStateInfo(false);
                            return !prev;
                          });
                        }}
                      >
                        {expandAllStateInfo ? <CollapseAll /> : <ExpandAll />}
                      </JsonExpandCollapse>
                    </h4>
                    <>
                      {expandAllStateInfo && (
                        <JSONTree
                          name={false}
                          displayDataTypes={false}
                          displayObjectSize={false}
                          collapsed={expandAllStateInfo ? false : DEFAULT_JSON_LENGTH}
                          src={devices}
                        />
                      )}
                    </>
                  </>
                ) : (
                  <>
                    <h4> Vehicle Information </h4>
                    <p> {NO_PAGE_DATA.VEHICLE_NO_DATA} </p>
                  </>
                )}
              </div>
            </JsonTree>
          </>
        </div>
      ) : null}
      {showAddon ? (
        <div className="addonsInfoSubs">
          <>
            <JsonTree>
              <div className="tree-grid">
                {addons && Array.isArray(addons) && addons.length > 0 ? (
                  <>
                    <h4>
                      Addon Information
                      <JsonExpandCollapse
                        onClick={() => {
                          setExpandAllStateInfo((prev) => {
                            setViewStateInfo(false);
                            return !prev;
                          });
                        }}
                      >
                        {expandAllStateInfo ? <CollapseAll /> : <ExpandAll />}
                      </JsonExpandCollapse>
                    </h4>
                    <>
                      {expandAllStateInfo && (
                        <JSONTree
                          name={false}
                          displayDataTypes={false}
                          displayObjectSize={false}
                          collapsed={expandAllStateInfo ? false : DEFAULT_JSON_LENGTH}
                          src={addons}
                        />
                      )}
                    </>
                  </>
                ) : (
                  <>
                    <h4> Addon Information </h4>
                    <p> {NO_PAGE_DATA.ADDON_NO_DATA} </p>
                  </>
                )}
              </div>
            </JsonTree>
          </>
        </div>
      ) : null}
    </DetailContainer>
  );
};

export default orderDeviceInfo;
